import {PlayerBase} from "../../player/player.base";
import {Component, Injector, ViewChild} from '@angular/core';
import {Observable, of, switchMap, takeUntil} from 'rxjs';
import {catchError} from "rxjs/operators";
import {PlayerBaseService} from "../../services/PlayerService/player.base.service";



@Component({
  selector: 'app-button',
  template: '<div #component><button #btn style="width: 100%; height: 100%" [style.fontSize]="fontSize" [style.color]="color" [style.backgroundColor]="bgColor" [style.fontFamily]="fontFamily" mat-raised-button>{{label}}</button></div>',
  styleUrls: []
})
export class PttMicComponent extends PlayerBase {

  @ViewChild('btn', {static: true} ) btn;

  label;
  fontSize;
  color;
  bgColor;
  fontFamily;
  fontStyle;

  emergency = false;
  stations;

  mediaRecorder;
  mediaSource;

  downEvent;
  upEvent;
  onBtnPress;
  onBtnRelease;

  constructor(protected  injector: Injector) {
    super(injector);
  }


  load(playerObject: any): Observable<any> {
    let self;
    return super.load(playerObject).pipe(
      switchMap( playerBase => {
        self = playerBase;
        try {
          this.stations = this.data.Button[0].$.fieldName;
        } catch (e) {
        }

        if (this.playerService.os==PlayerBaseService.OS_ANDROID) {
          this.downEvent = 'touchstart';
          this.upEvent = 'touchend';
        } else {
          this.downEvent = 'mousedown';
          this.upEvent = 'mouseup';
        }

        this.onBtnPress = e => { this.pttStart(); }
        this.onBtnRelease = e => { this.pttStop(); }
        this.component.nativeElement.addEventListener(this.downEvent, this.onBtnPress);
        this.component.nativeElement.addEventListener(this.upEvent, this.onBtnRelease);

        const font = this.data.Button[0].Font[0].$;
        this.fontStyle = this.getFontStyle(font);
        return this.playerService.caching.requestFont(font)
      }),
      switchMap( a => {
        this.fontSize = this.fontStyle.fontSize + 'px';
        this.color = this.fontStyle.fill;
        this.fontFamily = this.fontStyle.fontFamily;
        this.label = this.data.Button[0].$.label;
        this.changeDetectorRef.detectChanges();
        return of('a');
      }),
      catchError( err => this.logError(err) ),
      switchMap(a => of(self)),
      takeUntil(this.finish$)
    )
  }

  createBackgroundAction() {
      const color = Number(this.data.Background[0].$.color);
      const r = color & 0xff;
      const g = (color>>8) & 0xff;
      const b = (color>>16) & 0xff;
      const alpha = Number(this.data.Background[0].$.alpha);

      this.bgColor = 'rgba(' + b + ',' + g + ',' + r + ',' +  alpha + ')';
  }

    clearEffects() {
        super.clearEffects();
        this.bgColor = '';
    }


    pttStart() {
    navigator.mediaDevices.getUserMedia({ audio: true  }).then((stream) => {
      this.mediaRecorder = new MediaRecorder(stream);
      this.mediaRecorder.ondataavailable = (e) => {
        const blob = <Blob>e.data;
        this.playerService.sendPttBlob(this.stations, this.emergency, blob);
      }
      this.mediaRecorder.onstop = (e) => {
        stream.getTracks().forEach( (track) => {
          track.stop();
        });

      }
      this.mediaRecorder.start();
    }).catch((err) => {
      alert("error")
    });


  }

  pttStop() {
    if (this.mediaRecorder!=null) {
      this.mediaRecorder.stop()
    }
  }


  destroy(): void {
    if (this.onBtnPress!=null) {
      this.component.nativeElement.removeEventListener(this.downEvent, this.onBtnPress);
      this.onBtnPress = null;
    }
    if (this.onBtnRelease!=null) {
      this.component.nativeElement.removeEventListener(this.upEvent, this.onBtnRelease);
      this.onBtnRelease = null;
    }

    super.destroy();
  }
}
